module.exports = __webpack_public_path__ + "static/img/0402_05.a6d39aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/04/0402_05.png
// module id = BsOX
// module chunks = 1